// extracted by mini-css-extract-plugin
export var button = "_kd-2";
export var card = "_kd-0";
export var closeButtonContainer = "_kd-3";
export var iconContainer = "_kd-1";